import { CoverageSchema } from '@/services/types/coverage-types';

import { CoverageCard } from '../shared/CoverageCard';

interface MergeStepPreviewProps {
  destinationCoverage: CoverageSchema;
  sourceCoverages: CoverageSchema[];
}

export const MergeStepPreview = ({
  destinationCoverage,
  sourceCoverages,
}: MergeStepPreviewProps) => {
  return (
    <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-200">
      <div className="mb-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-2">
          Merge Preview
        </h2>
        <p className="text-gray-600">
          Review what will happen when you merge these coverages.
        </p>
      </div>

      <div className="space-y-8">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <div className="w-2 h-2 rounded-full bg-green-500" />
            <h3 className="text-sm font-semibold text-green-700">
              Destination (will be kept and updated)
            </h3>
          </div>
          <CoverageCard coverage={destinationCoverage} />
        </div>

        <div>
          <div className="flex items-center gap-2 mb-4">
            <div className="w-2 h-2 rounded-full bg-amber-500" />
            <h3 className="text-sm font-semibold text-amber-700">
              Sources (will be merged and deleted)
            </h3>
          </div>
          <div className="space-y-4">
            {sourceCoverages.map((coverage) => (
              <CoverageCard key={coverage.id} coverage={coverage} />
            ))}
          </div>
        </div>
      </div>

      <div className="mt-8 p-4 bg-amber-50 border border-amber-200 rounded-lg">
        <div className="flex gap-3">
          <div className="flex-shrink-0">
            <div className="w-5 h-5 rounded-full bg-amber-100 flex items-center justify-center">
              <span className="text-amber-600 text-xs font-bold">!</span>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-medium text-amber-800 mb-1">
              Warning: This action cannot be undone
            </h4>
            <p className="text-sm text-amber-700">
              The source coverage entries will be permanently deleted after
              their data is merged into the destination coverage. Make sure you
              have selected the correct destination.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
